<template>
    <div>
        <div>
            <BeginningChallengeContainer />
        </div>
    </div>
</template>
<script>
import BeginningChallengeContainer from '@/components/challenge/beginningStudents/BeginningChallengeContainer.vue';
export default {
    components: {
        BeginningChallengeContainer
    }
}
</script>
<style lang="">

</style>
